import { Box, Grid, Tooltip, Typography } from "@mui/material";
import { ReactNode, useMemo } from "react";
import "../../../components/ContactsManagement/contact.css";

// Field configuration interface
export interface CardField {
  key: string;
  label: string;
  value: string | number | null | undefined | ReactNode;
  tooltip?: boolean;
  ellipsis?: boolean;
  format?: (value: any) => string;
  customRender?: (value: any) => ReactNode;
}

// Action configuration interface
export interface CardAction {
  key: string;
  icon: ReactNode;
  tooltip: string;
  onClick: (item: any) => void;
  show?: (item: any) => boolean; // Conditional visibility
}

interface CommonCardProps {
  // Core data
  id: string | number;
  title: string;
  data: Record<string, any>; // All data fields
  
  // Configuration
  dynamicFields: CardField[];
  actions?: CardAction[];
  
  // Optional custom renderers
  headerRight?: ReactNode;
  customHeader?: ReactNode;
  customBody?: ReactNode;
  customFooter?: ReactNode;
  
  // Styling
  className?: string;
  gridSize?: {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
    xl?: number;
  };
  
  // Card props
  cardClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
}

const CommonCard = (props: CommonCardProps) => {
  const {
    id,
    title,
    data,
    dynamicFields,
    actions = [],
    headerRight,
    customHeader,
    customBody,
    customFooter,
    className = "",
    gridSize = { md: 3, xs: 12 },
    cardClassName = "",
    bodyClassName = "",
    footerClassName = "",
  } = props;

  // Helper function to format value
  const formatValue = (field: CardField) => {
    if (field.customRender) {
      return field.customRender(field.value);
    }
    if (field.format) {
      return field.format(field.value);
    }
    return field.value === "" || field.value === null || field.value === undefined 
      ? "------" 
      : field.value;
  };

  // Render dynamic fields
  const renderDynamicFields = () => {
    return dynamicFields.map((field) => {
      const value = formatValue(field);
      const content = (
        <Typography
          key={field.key}
          variant="body1"
          sx={
            field.ellipsis
              ? {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                  display: "block",
                }
              : {}
          }
        >
          <strong>{field.label}:</strong> {value}
        </Typography>
      );

      if (field.tooltip) {
        return (
          <Tooltip key={field.key} title={String(value)} arrow>
            {content}
          </Tooltip>
        );
      }

      return content;
    });
  };

  // Render actions
  const renderActions = () => {
    const visibleActions = actions.filter(action => 
      !action.show || action.show(data)
    );

    return visibleActions.map((action) => (
      <Tooltip key={action.key} title={action.tooltip}>
        <span
          onClick={() => action.onClick(data)}
          style={{ cursor: "pointer", display: "inline-flex" }}
        >
          {action.icon}
        </span>
      </Tooltip>
    ));
  };

  return (<>
    <Grid item {...gridSize} className={className}>
      <Box className={`${cardClassName}`}>
        {/* Card Header */}
        {customHeader || (
          <Box className="contact-card-header">
            <Tooltip title={title}>
              <Typography variant="body2" className="dynamic-card-title">
                #{id} : {title}
              </Typography>
              
            </Tooltip>
            {headerRight && (
              <Box className="contact-card-header-right">
                {headerRight}

                {/* <Typography
                  variant="body2"
                  className={`${classes.title} ${classes.AssetCount}`}
                  style={{ display: "contents" }}
                >
                  {alert && alert !== "" ? (
                    <Tooltip title={alert}>
                      <ReportProblemOutlinedIcon fontSize="small" color="warning" />
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                  {statusId !== 0 && (
                    <Box>
                      <Tooltip title={`Asset Status ${assetStatus?.name}`}>
                        <Typography
                          variant="body2"
                          className={`${classes.title} ${classes.ticketCardTags} `}
                        >
                          {assetStatus?.displayName}
                        </Typography>
                      </Tooltip>
                    </Box>
                  )}
                </Typography> */}
              </Box>
            )}
          </Box>
        )}

        {/* Card Body */}
        {customBody || (
          <Box className={`${bodyClassName}`}>
            {renderDynamicFields()}
          </Box>
        )}

        {/* Card Footer */}
        {customFooter || (
          <Box className={`pb-10p ${footerClassName}`}>
            {renderActions()}
          </Box>
        )}
      </Box>
    </Grid>
    {/* <Grid item {...gridSize} className={`cardlist ${className}`}>
            <Box className="contact-card">
              <Box className="contact-card-header">
                <Tooltip title={name}>
                  <Typography variant="body2">{name}</Typography>
                </Tooltip>
                <Typography
                  variant="body2"
                  className={`${classes.title} ${classes.AssetCount}`}
                  style={{ display: "contents" }}
                >
                  {alert && alert !== "" ? (
                    <Tooltip title={alert}>
                      <ReportProblemOutlinedIcon fontSize="small" color="warning" />
                    </Tooltip>
                  ) : (
                    <></>
                  )}
                  {statusId !== 0 && (
                    <Box>
                      <Tooltip title={`Asset Status ${assetStatus?.name}`}>
                        <Typography
                          variant="body2"
                          className={`${classes.title} ${classes.ticketCardTags} `}
                        >
                          {assetStatus?.displayName}
                        </Typography>
                      </Tooltip>
                    </Box>
                  )}
                </Typography>
              </Box>
    
              <Box className={`contact-card-body noFlex`}>
                <Typography variant="body1">ID : {id}</Typography>
                <Tooltip title={operatingSystem || "------"} arrow PopperProps={{ modifiers: [{name: "offset",options: {offset: [33, -9],},},],}}>
                  <Typography variant="body1" sx={{whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis",maxWidth: "100%",display: "block",}}>
                    Operating System :{" "}{operatingSystem === "" || operatingSystem === null
                      ? "------"
                      : operatingSystem}
                  </Typography>
                </Tooltip>
                <Typography variant="body1">
                  {" "}
                  Contact Name : {contacts?.name === "" || contacts?.name === null
                    ? "------"
                    : contacts?.name}{" "}
                </Typography>
                <Tooltip title={assetTag || "------"} arrow>
                  <Typography
                    variant="body1"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "inline-block",
                    }}
                  >
                    Tag:{" "}
                    {assetTag === "" || assetTag === null ? "------" : assetTag}
                  </Typography>
                </Tooltip>
              </Box>
    
              <Box className={"contact-card-footer"}>{actions}</Box>
            </Box>
          </Grid> */}
    </>
  );
};

export default CommonCard;